import React, { useState } from 'react';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';
import {
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import SidebarSheetWrapper from '@/js/components/sidebars/SidebarSheetWrapper';
import LeftSidebar from '@/js/components/sidebars/LeftSidebar';
import { useNavigate } from 'react-router-dom';
import SearchScreen from '@/js/screens/Buyer/SearchScreen';

// Custom useMediaQuery hook for responsive behavior
const useMediaQuery = (query) => {
  const [matches, setMatches] = React.useState(false);

  React.useEffect(() => {
    const media = window.matchMedia(query);
    setMatches(media.matches);

    const listener = () => setMatches(media.matches);
    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
  }, [query]);

  return matches;
};

const SearchPage = () => {
  const responsive = useMediaQuery('(min-width: 1024px)');
  const navigate = useNavigate();

  return (
    <div className="px-6 font-roboto bg-backgroundGray min-h-[calc(100vh-70px)] relative">
      <div className="absolute left-5 top-3">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink
              className="text-[13px] text-gray-700 font-semibold hover:text-darkerPurple cursor-pointer ease-in-out duration-150 transition-colors"
              onClick={() => {
                navigate('/buyer/dashboard');
              }}
            >
              Dashboard
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink className="text-[13px] font-semibold text-darkPurple hover:text-darkerPurple cursor-pointer ease-in-out duration-150 transition-colors">
              Search Manufacturer
            </BreadcrumbLink>
          </BreadcrumbItem>
        </BreadcrumbList>
      </div>
      <div className="grid grid-cols-custom12 min-h-[calc(100vh-70px)]">
        <div className="lg:hidden col-span-12 p-4">
          <Drawer>
            <DrawerTrigger asChild>
              <Menu size={28} className="cursor-pointer mt-7 ml-5" />
            </DrawerTrigger>
            <DrawerContent>
              <div className="mx-auto w-full max-w-sm">
                <DrawerHeader>
                  <DrawerTitle>Menu</DrawerTitle>
                </DrawerHeader>
                <LeftSidebar role="buyer" />
                <DrawerClose asChild>
                  <Button variant="outline" className="w-full">
                    Close
                  </Button>
                </DrawerClose>
              </div>
            </DrawerContent>
          </Drawer>
        </div>

        {/* Desktop Sidebar */}
        {/* <div className="hidden lg:block lg:col-span-1">
          <div className="side-menu h-full pt-5">
            <SidebarSheetWrapper role="buyer" />
          </div>
        </div> */}

        {/* Main Content */}
        <div className="col-span-12 mt-10 mb-4 mx-3 rounded-lg">
          <SearchScreen />
        </div>
      </div>
    </div>
  );
};

export default SearchPage;
